const defaultValues = {
  NODE_ENV: 'development',
  BASE_URL: '/',

  VUE_APP_VERSION: '0.1.0',
  VUE_APP_DEPLOY_TARGET: 'local',
  VUE_APP_STORAGE_PREFIX: 'loyall-clients',
  VUE_APP_REST_API_URL: 'http://localhost:10000',
};

export default { ...defaultValues, ...process.env };

export const loyallFunds = [
  {
    // CROSSALPHA (PRD)
    serial: '28077425000118',
    houseFundId: '5f6e773d72b7ea0011ed0a15',
  },

  {
    // CROSSCHECK (PRD)
    serial: '28227560000100',
    houseFundId: '5f6e775972b7ea0011ed0a1f',
  },

  {
    // CROSSOVER (PRD)
    serial: '20056898000127',
    houseFundId: '5f6e775372b7ea0011ed0a1d',
  },
];
